<div [alarisLoading]="loading$">
	<div class="edit-panel-header">
		<alaris-icon name="icon-edit-list"></alaris-icon>
		<span
			>{{
				group.id
					? ('contacts.contactGroup' | translate) + ': ' + (group.name | translate)
					: ('contacts.addNewGroup' | translate)
			}}
		</span>
	</div>
	<div alarisFade="vertical" class="edit-panel-content">
		@if ((importHistory$ | async)?.length && ([CP_PERMISSIONS.CONTACTS_E] | alarisPBAC)) {
			<alaris-tabs #senderDetailTabs [underline]="true">
				<alaris-tab [label]="'actions.edit' | translate" tabId="edit">
					<ng-container [ngTemplateOutlet]="editOrAddForm"></ng-container>
				</alaris-tab>
				<alaris-tab [label]="'contacts.importHistory' | translate" tabId="importHistory">
					<ng-container [ngTemplateOutlet]="importHistory"></ng-container>
				</alaris-tab>
			</alaris-tabs>
		} @else {
			<ng-container [ngTemplateOutlet]="editOrAddForm"></ng-container>
		}
	</div>

	<div *alarisPBAC="[CP_PERMISSIONS.CONTACTS_E]" class="edit-panel-footer">
		<button alaris-button bType="primary" data-testid="saveBtn" form="ngForm" size="lg">
			<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
			{{ (group.id ? 'actions.save' : 'actions.create') | translate }}
		</button>

		<button (click)="close()" alaris-button bType="outline" data-testid="cancelBtn" size="lg" type="button">
			{{ 'actions.cancel' | translate }}
		</button>
	</div>
</div>

<ng-template #editOrAddForm>
	<form (ngSubmit)="save()" [formGroup]="form" alarisFocusFirstInvalidInput class="flex-box" id="ngForm">
		@if (group.id) {
			<div class="date-box">
				<div class="date">
					{{ 'contacts.creationDate' | translate }}:
					{{ group.creationDate | dateFormat }}
				</div>
				@if (group.lastUpdated) {
					<div class="date">
						{{ 'gl.lastUpdated' | translate | uppercase }}:
						{{ group.lastUpdated | dateFormat }}
					</div>
				}
			</div>
		}

		<alaris-input
			[label]="'contacts.name' | translate"
			[placeholder]="'contacts.name' | translate"
			[required]="true"
			class="w-100"
			data-testid="nameInput"
			errorMode="touched"
			formControlName="name"
		>
		</alaris-input>
		<alaris-text-area class="w-100" data-testid="descriptionTextarea" formControlName="description">
			{{ 'contacts.description' | translate }}
		</alaris-text-area>
	</form>
</ng-template>

<ng-template #importHistory>
	@for (history of importHistory$ | async; track history; let first = $first) {
		<alaris-card [class.first]="first" class="card" size="auto">
			<button (click)="export(history)" [attr.data-testid]="'exportBtn/' + history.file.id" class="reset file-info">
				<alaris-icon class="icon" name="icon-arrow-save"></alaris-icon>
				<div class="header">{{ 'contacts.import.file' | translate }}</div>
				<div class="name">{{ history.file.name }}</div>
			</button>
			<div [attr.data-testid]="'statistics/' + history.file.id" class="statistics">
				<div class="item">
					<span class="header">{{ 'contacts.totalRows' | translate }}</span>
					<span class="amount">{{ history.total }}</span>
				</div>
				<div class="item">
					<span class="header">{{ 'contacts.addedRows' | translate }}</span>
					<span class="amount">{{ history.added }}</span>
				</div>
				<div class="item">
					<span class="header">{{ 'contacts.updatedRows' | translate }}</span>
					<span class="amount">{{ history.updated }}</span>
				</div>
				<div class="item">
					<span class="header">{{ 'contacts.errorCount' | translate }}</span>
					<span class="amount">{{ history.errors }}</span>
				</div>
			</div>
			<div class="additions-info">
				@if (history?.createdBy) {
					<div
						class="item user"
						[alarisTooltip]="(history?.createdBy | noValue) === '-' ? '' : (history?.createdBy ?? '')"
						[overflow]="true"
					>
						<alaris-icon name="icon-user-circle"></alaris-icon>
						<div [alarisTooltip]="history?.createdBy ?? '' | contactUser" [overflow]="true" class="ellipsis">
							{{ history?.createdBy ?? '' | contactUser | noValue }}
						</div>
					</div>
				}
				@if (history?.creationDate) {
					<div class="item">
						<alaris-icon name="icon-data"></alaris-icon>
						{{ history?.creationDate | dateFormat }}
					</div>
				}
				@if (history.errors) {
					<button
						(click)="getErrorReport(history.id)"
						[attr.data-testid]="'errorReportBtn/' + history.file.id"
						class="item report"
					>
						<alaris-icon name="icon-file-arrow-down"></alaris-icon>
						{{ 'contacts.errorReport' | translate }}
					</button>
				}
			</div>
		</alaris-card>
	}
</ng-template>
